import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { css, cx } from '@emotion/css';
import { useRef } from 'react';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { observer } from 'mobx-react-lite';
const buttonStyle = css `
    &:after {
        opacity: 0;
        content: '';
        background: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100%;
        position: absolute;
        border-radius: var(--swan-sem-border-radius-subtle);
        border: 1px solid rgba(0, 0, 0, 0.3);
        pointer-events: none;
    }
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid #e1e6eb;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: var(--swan-sem-border-radius-subtle);
    background-color: #f8f8f8;
    padding: 0;
`;
const multiPageButtonStyle = css `
    height: 100%;
    width: 100%;
    float: right;
`;
const draggableContainerStyle = css `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
`;
export const DrawerThumbnailButton = observer((props) => {
    const { onClick, onDoubleClick, className, children } = props;
    const { asset, asset: { status, isPresigned }, isMultiPage, pageNumber, } = useDrawerThumbnailAsset();
    const ref = useRef(null);
    const isMultiPageButton = isMultiPage && status.type === AssetStatusType.Prepared && isPresigned;
    const handleCTA = (func) => {
        var _a;
        func === null || func === void 0 ? void 0 : func(asset, pageNumber);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    const onKeyDown = (event) => {
        const { key } = event;
        if (key && (key === 'Enter' || key === ' ')) {
            event.preventDefault();
            // If the asset is not prepared (either still uploading, or being deleted) we won't trigger events
            if (asset.status.type !== AssetStatusType.Prepared) {
                return;
            }
            if (onClick) {
                handleCTA(onClick);
            }
            else if (onDoubleClick) {
                event.preventDefault();
                handleCTA(onDoubleClick);
            }
        }
    };
    return (_jsxs("button", Object.assign({ ref: ref, className: cx('drawer-thumbnail-button', buttonStyle, isMultiPageButton && multiPageButtonStyle, className), onKeyDown: onKeyDown, onClick: () => handleCTA(onClick), onDoubleClick: () => handleCTA(onDoubleClick) }, { children: [children, _jsx("div", { className: draggableContainerStyle })] })));
});
DrawerThumbnailButton.displayName = 'DrawerThumbnailButton';
//# sourceMappingURL=DrawerThumbnailButton.js.map